<template>
  <div
    class="-highlight-rect"
    :style="styleObj"
    :class="{ '-bottom': isBottom }"
  >
    <div
      title="Edit"
      class="wticon wticon-edit-04 wt2-color-link"
      @click="$emit('edit')"
    />
    <div
      title="Delete"
      class="wticon wticon-trash-line wt2-color-link"
      @click="$emit('delete')"
    />
    <span class="-arrow" />
  </div>
</template>

<script>
export default {
  name: 'transcribe-highlight-menu',

  props: {
    selectionRect: { type: Object, required: true },
    isFirst: { type: Boolean, required: true },
  },

  mounted() {
    this.$emit('mounted');
  },

  computed: {
    styleObj() {
      return {
        top: this.selectionRect.top + 'px',
        left: this.selectionRect.left + 'px',
      };
    },

    isBottom() {
      return this.isFirst && this.selectionRect.top < 25;
    },
  },
};
</script>

<style scoped lang="scss">
.-highlight-rect {
  position: absolute;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
  transform: translate(-50%, calc(-100% - 10px));
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 11;
  padding: 0 5px;

  &.-bottom {
    transform: translate(-50%, 30px);
    .-arrow {
      bottom: initial;
      top: -10px;
      left: 30px;
      transform: rotate(180deg);
    }
  }

  .wticon {
    cursor: pointer;
    padding: 10px;
    font-size: 16px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    &:not(:last-of-type) {
      border-right: 1px solid #d9d9d9;
    }
  }

  .-arrow {
    width: 20px;
    height: 10px;
    position: absolute;
    bottom: -10px;
    left: 50%;
    overflow: hidden;
    transform: translateX(-50%);

    &:after {
      content: '';
      position: absolute;
      width: 24px;
      height: 12px;
      background: white;
      transform: rotate(45deg);
      top: -14px;
      left: -7px;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
    }
  }
}
</style>
